import { Flex } from '@cognite/cogs.js-v10';
import styled from 'styled-components';

export const Wrapper = styled(Flex).attrs({ gap: 6, direction: 'column' })`
  flex: 1;
  background-color: ${({ theme }) => theme['surface--strong']};
  padding: 8px;
  border-radius: var(--cogs-border-radius--small);
`;
